const userTypes = {
  USER_REQUEST: "USER_REQUEST",
  USER_FAILURE: "USER_FAILURE",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_UPDATE_SUCCESS: "USER_UPDATE_SUCCESS",
  CLEAR_ERROR_MESSAGES: "CLEAR_ERROR_MESSAGES",
};

export default userTypes;
